import { Injectable } from '@angular/core';
import { getDate, getMonth } from "date-fns";
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, firstValueFrom, Observable, of } from 'rxjs';
import { LinkPreview, MoodValue } from "@teammood/timeline";
import { LoggerService } from "@teammood/shared/util/logger";
import Delta from "quill-delta";

@Injectable({
    providedIn: 'root'
})
export class MoodsService {

    constructor(
        private http: HttpClient,
        private logger: LoggerService
    ) {}

    /**
     * Return mood class icon corresponding to the mood value with specific icon for Halloween and Easter
     */
    build_icon(mood: string, date: Date): string {
        if (date) {
            const day = getDate(date);
            const month = getMonth(date) +1 ;

            if (day === 1 && month === 4) {
                return "far fa-fish " + mood;
            }

            if (day === 31 && month === 10) {
                if(mood === 'excellent' || mood === 'good'){
                    return "far fa-jack-o-lantern " + mood;
                } else {
                    return 'fa-kit fa-' + mood + '-jack-o-lantern ' + mood;
                }
            }
        }
        return "icon-smileys-" + mood;
    }

    async getMoods(moodId: string): Promise<CreatedMoods> {
        return await firstValueFrom(
            this.http.get<CreatedMoods>('/api/moods/' + moodId).pipe(

                catchError(err => {
                    if (err instanceof HttpErrorResponse && err.status === 401) {
                        return EMPTY;
                    } else {
                        this.logger.error(`unable to get moods from moodId ${moodId}`, err);
                        const empty: CreatedMoods = {
                            createdRecently: false,
                            moods: [],
                        }
                        return of(empty)
                    }
                })
            )
        );
    }


    async getCommentLinkPreviews(comment: string): Promise<LinkPreview[]> {
        console.log('comment', comment)
        if (comment.includes("http")) {
            if(comment.includes(" http") === false){
                comment = comment.split("http").join(' http');
            }
            return await firstValueFrom(this.http.post<LinkPreview[]>('/api/comment/linkpreviews/', {"comment": comment}));
        } else {
            return [];
        }
    }


    getDeltaLinkPreviews(delta: Delta): Observable<LinkPreview[]> {
        return this.http.post<LinkPreview[]>('/api/content/linkpreviews/', delta);
    }

    sanitizeComment(comment: string): string {
        if (comment) {
            return comment
                .replace(/<br>/g, '\n')
                .replace(/&#10;/g, '\n')
                .replace('%@', '%'); // weird bug on IE 11, it does not like comments containing '%@'
        } else {
            return comment
        }
    }

    addSpaceBeforeLink(textToFix: string): string {
        if(textToFix){
            if (textToFix.includes("http")) {
                if (textToFix.includes(" http") === false) {
                    return textToFix.split("http").join(' http');
                }
            }
        }
        return textToFix;
    }

}

export interface CreatedMood {
    id: string,
    mood: MoodValue,
    teamName: string,
    teamId: string,
    codeOfConductLabel: string,
    day: number
}

export interface CreatedMoods {
    createdRecently: boolean,
    moods: CreatedMood[]
}
